import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const SLOGAN = "Najin trenutek, vaši pogledi, večni spomini.";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center ${className}`} data-testid="brand-logo-link">
    <img src="/brand/logo-header.webp" alt="Najin trenutek" className="h-12 sm:h-14 w-auto mix-blend-multiply" />
  </Link>
);

const LINKS = [["/#kako-deluje", "Kako deluje"], ["/#cenik", "Cenik"], ["/#izdelki", "Izdelki"], ["/o-naju", "O naju"], ["/#vprasanja", "Vprašanja"], ["/#kontakt", "Kontakt"]];
const tid = (h) => h.replace(/^\/#?/, "");

const NavItem = ({ h, l, className, onClick, prefix = "nav" }) =>
  h.includes("#")
    ? <a href={h} onClick={onClick} className={className} data-testid={`${prefix}-${tid(h)}`}>{l}</a>
    : <Link to={h} onClick={onClick} className={className} data-testid={`${prefix}-${tid(h)}`}>{l}</Link>;

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const dash = user ? (user.role === "admin" ? "/admin" : "/nadzorna-plosca") : "/prijava";
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#FAF7F2]/85 border-b border-[#EADBCE]/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8 text-sm text-[#6C6560]">
          {LINKS.map(([h, l]) => (
            <NavItem key={h} h={h} l={l} className="hover:text-[#231F20] transition-colors" />
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to={dash} className="text-sm px-4 py-2 hover:text-[#B39264] transition-colors" data-testid="nav-login-link">{user ? "Nadzorna plošča" : "Prijava"}</Link>
          <Link to="/ustvari" className="btn-dark text-sm px-5 py-2.5" data-testid="nav-create-wedding">Ustvarita svojo poroko</Link>
        </div>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Meni">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#EADBCE] bg-[#FAF7F2] px-6 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map(([h, l]) => <NavItem key={h} h={h} l={l} prefix="nav-mobile" onClick={() => setOpen(false)} className="text-[#231F20]" />)}
          <Link to={dash} className="text-[#231F20]" data-testid="nav-mobile-login">{user ? "Nadzorna plošča" : "Prijava"}</Link>
          <Link to="/ustvari" className="btn-dark text-center py-3" data-testid="nav-mobile-create">Ustvarita svojo poroko</Link>
        </div>
      )}
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="border-t border-[#EADBCE] bg-[#F3ECE1]/60" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div className="space-y-3">
          <img src="/brand/logo.webp" alt="Najin trenutek" className="w-48 mix-blend-multiply" data-testid="footer-logo" />
          <p className="font-display italic text-lg" data-testid="footer-slogan">{SLOGAN}</p>
          <p className="text-sm text-[#6C6560] max-w-xs">Zasebne poročne galerije s QR kodo. Brez aplikacije, brez registracije za goste.</p>
        </div>
        <div className="text-sm space-y-2">
          <p className="eyebrow mb-3">Pravne informacije</p>
          <Link to="/o-naju" className="block text-[#6C6560] hover:text-[#231F20]" data-testid="footer-about">O naju</Link>
          <Link to="/pravno/zasebnost" className="block text-[#6C6560] hover:text-[#231F20]" data-testid="footer-privacy">Politika zasebnosti</Link>
          <Link to="/pravno/pogoji" className="block text-[#6C6560] hover:text-[#231F20]" data-testid="footer-terms">Splošni pogoji</Link>
          <Link to="/pravno/hramba" className="block text-[#6C6560] hover:text-[#231F20]" data-testid="footer-retention">Hramba in izbris podatkov</Link>
        </div>
        <div className="text-sm text-[#6C6560] space-y-1">
          <p className="eyebrow mb-3">Ponudnik storitve</p>
          <p data-testid="footer-company-name">Matej Španinger s.p.</p>
          <p data-testid="footer-company-address">Mejna ulica 6, Skoke</p>
          <p data-testid="footer-company-tax">Davčna številka: 50556533</p>
          <p><a href="mailto:info@najintrenutek.eu" className="hover:text-[#231F20]" data-testid="footer-company-email">info@najintrenutek.eu</a></p>
        </div>
      </div>
      <div className="text-center text-xs text-[#968E87] pb-8">© {new Date().getFullYear()} Najin trenutek. Vse pravice pridržane.</div>
    </footer>
  );
}
